module.exports = __webpack_public_path__ + "media/assets/validation_positive-1822700f10fdc4287e689f8c3822fcbd.svg";